import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";

import { createStyles, makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Button, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import ModalNotice from "../../components/modals/ModalNotice";
import ModalRemoveSupplierNotice from "../../components/modals/modalRemoveSupplierNotice";
import ModalSuplierInfo from "../../components/modals/ModalSuplierInfo";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  NOTICE_FILTER,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  TABLE_FILTER,
  TABLE_SUPPNOTICE_ROWNumber,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { Filter, FilterNotice } from "../../models/cartable.model";
import {
  BasicNoticeResponse,
  GetSupplierNoticesRequest,
  NoticeTypeEnum,
} from "../../models/supplierNotice.model";
import {
  GetAllNotices,
  GetNoticeTypes,
} from "../../services/supplierNotice.service";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: `${muiSelected} !important`,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const columns: readonly ColumnModel[] = [
  // { id: "noticeType", label: "نوع پیام" },
  // { id: "creationDatePersian", label: "تاریخ و زمان ارسال" },
  { id: "creatorFullName", label: "کاربر سیستم" },
  {
    id: "title",
    label: "عنوان پیام ",
  },
  // {
  //     id: "noticeUserCount",
  //     label: "تعداد ارسال",
  //     hasFormat: true,
  //     format: (vlaue: number) => {
  //         return `${vlaue}`;
  //     },
  // },
];

let muiSelected: any;

export default function NotificationList() {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;

  /*********** filter added */
  const history = useHistory();
  const queryClient = useQueryClient();

  const oldPage = queryClient.getQueryData<Filter>(TABLE_SUPPNOTICE_ROWNumber);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [data, setData] = React.useState<BasicNoticeResponse[]>([]);
  const [valueNoticeType, setValueNoticeType] = useState<string[]>([]);
  const [noticeTypeOptions, setNoticeTypeOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [valueNoticeTitle, setValueNoticeTitle] = useState<any>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalShowNoticeInfo, setOpenModalShowNoticeInfo] = useState<
    boolean
  >(false);
  const [noticeKeyModal, setNoticeKeyModal] = useState<string>();
  const [noticeKeyModalShowNotice, setNoticeKeyModalShowNotice] = useState<
    string
  >();
  const [sendConfirmation, setSendConfirmation] = React.useState(false);
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);

  const filter = new FilterNotice();
  function changeValueNoticeType(e: any) {
    const noticeTypeArray = [];
    noticeTypeArray.push(e.target.value);
    setValueNoticeType(noticeTypeArray);
  }
  function changeValueNoticeTitle(e: any) {
    setValueNoticeTitle(e.currentTarget.value);
  }

  function clickOpenModal(noticeKey: string) {
    setOpenModal(true);
    setNoticeKeyModal(noticeKey);
  }
  const classes = useStyles();

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const GetSupplierNoticesMutation = useMutation(GetAllNotices, {
    onSuccess: (result: ApiResultModel<BasicNoticeResponse[]>) => {
      if (result) {
        setData(result.data);
        setPageInfo(result.pageInfo);
      }
    },
  });

  const changePageNumber = (newPageNumber: number) => {
    const noticeFilter = queryClient.getQueryData<FilterNotice>(NOTICE_FILTER);
    fillData(noticeFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const generateFilter = (
    filterData: FilterNotice
  ): GetSupplierNoticesRequest => {
    let request = new GetSupplierNoticesRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: FilterNotice) => {
    let filter = generateFilter(filterData);
    GetSupplierNoticesMutation.mutate(filter);
  };
  React.useEffect(() => {
    const filterData = new FilterNotice();
    fillData(filterData!);
  }, []);
  React.useEffect(() => {
    let row: any;
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_SUPPNOTICE_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_SUPPNOTICE_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    const filter = new FilterNotice();

    fillData(filter);
    // let nationalCache = queryClient.getQueryData<string>(NATIONAL);
    // let suppIdCache = queryClient.getQueryData<string[]>(SUPPLIER_ID);
    // filter.customerNationalCode = nationalCache;
    // filter.supplierIds = suppIdCache;
    // if (stateCartable.stateCartable) {
    //   fillData(filter);
    // }
    //  fillData();
  }, []);
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };
  const handleDetail = (referenceKey: string, rowIndex: number) => {
    window.sessionStorage.setItem("id", referenceKey);
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);

    //TODO
    // history.push({
    //     pathname: `/loan/${activePage}1/loan-detail`,
    //     state: { id: referenceKey },
    // });
  };

  const handleEditNoticeItem = (rowIndex: any, noticeKey: string) => {
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    history.push({
      pathname: `/setting/addNotification`,
      state: { noticeKey: noticeKey },
    });
  };
  const handleShowNoticeItem = (rowIndex: any, noticeKey: string) => {
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    setNoticeKeyModalShowNotice(noticeKey);
    setOpenModalShowNoticeInfo(true);
  };

  const handleSelectRow = (rowIndex: any) => {
    const filter = new Filter();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER, filter);
  };

  const handelCreateNewNotice = () => {
    return history.push("/setting/AddNotification");
  };
  const handleRemoveFilter = () => {
    queryClient.setQueryData(NOTICE_FILTER, null);
    const noticeFilter = queryClient.setQueryData(NOTICE_FILTER, null);
    fillData(noticeFilter!);
    // changePageNumber(1);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
    setValueNoticeTitle("");
    setValueNoticeType([]);
  };
  useQuery<GetStatusResponse[]>("noticeTypeOptions", GetNoticeTypes, {
    onSuccess(data) {
      setNoticeTypeOptions(data);
    },
  });

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <div onClick={handelCreateNewNotice}>
            <AddCircleOutlineIcon
              className=" SuccessDefaultFont cursorPointer"
              style={{ width: "24px", height: "24px" }}
            />
            <span
              className="cursorPointer SuccessDefaultFont"
              style={{
                marginRight: "10px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              // onClick={handelCreateNewNotice}
            >
              افزودن اطلاعیه
            </span>
          </div>
        </Grid>
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              queryClient.setQueryData(NOTICE_FILTER, values);
              values.noticeType = valueNoticeType;
              values.title = valueNoticeTitle;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
              // changePageNumber(1);
            }}
          >
            {({ handleSubmit, handleChange, values, handleReset }) => (
              <form onSubmit={handleSubmit} onChange={handleChange}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <DropdownCmp2
                      onChange={changeValueNoticeType}
                      value={valueNoticeType}
                      label={"نوع پیام"}
                      options={noticeTypeOptions}
                      name="noticeType"
                      id="noticeType"
                      paddingRight="0vh"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"عنوان پیام"}
                      label={"عنوان پیام"}
                      required={false}
                      value={valueNoticeTitle}
                      onChange={changeValueNoticeTitle}
                      name="noticeTitle"
                      id="noticeTitle"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      فیلتر
                    </Button>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    {values ? (
                      <Button
                        type="button"
                        onClick={() => {
                          handleRemoveFilter();
                          handleReset();
                        }}
                        style={{
                          justifyContent: "right",
                          minWidth: "25px",
                          marginRight: "-1vh",
                        }}
                      >
                        <img
                          style={{ height: "24px", width: "24px" }}
                          src="images/RemoveAllFilters.svg"
                        />
                      </Button>
                    ) : null}
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Box>
        <Grid item xs={12} style={{ paddingTop: "1.5vh" }}>
          <div className="cardTableBorder">
            <TableContainer
              style={{ background: "#fff", maxHeight: "55vh" }}
              className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table tabsScroll"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                    selected={selectedRow === 0}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont14  noWrap"
                      align="right"
                    >
                      نوع پیام
                    </TableCell>
                    <TableCell
                      className="rowTHead colorTitle textFont14  noWrap"
                      align="right"
                    >
                      تاریخ و زمان ارسال
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont14  noWrap"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      className="rowTHead colorTitle textFont14  noWrap"
                      align="right"
                    >
                      تعداد ارسال
                    </TableCell>
                    <TableCell className="rowTHead colorTitle" align="right">
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        style={{ color: "#1D4A87" }}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>

                <TableBody>
                  {data
                    ? data.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft cursorPointer noWrap`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.noticeKey}
                            selected={selectedRow === rowIndex}
                          >
                            <TableCell
                              className={
                                row.noticeType === "Information"
                                  ? "InformationDefaultFont textFont14"
                                  : "DangerDefaultFont textFont14"
                              }
                              align="right"
                            >
                              {
                                NoticeTypeEnum[
                                  row.noticeType as keyof typeof NoticeTypeEnum
                                ]
                              }
                            </TableCell>
                            <TableCell
                              className={`${
                                row.creationDatePersian
                                  ? "actionButtonHeader fontBlueColor textFont14"
                                  : "fontBlueColor textFont14"
                              }`}
                              align="right"
                            >
                              {row.creationDatePersian}
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[column.id as keyof BasicNoticeResponse];
                              return (
                                <>
                                  <TableCell
                                    className="fontBlueColor textFont14"
                                    key={column.id}
                                    align="right"
                                  >
                                    {column.id == "noticeType"
                                      ? NoticeTypeEnum[
                                          row.noticeType as keyof typeof NoticeTypeEnum
                                        ]
                                      : column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                </>
                              );
                            })}
                            <TableCell
                              className={
                                row.noticeUserCount > 0
                                  ? "colorCount textFont14"
                                  : "colorBlack textFont14"
                              }
                              onClick={
                                row.noticeUserCount > 0
                                  ? () => clickOpenModal(row.noticeKey)
                                  : () => ""
                              }
                              align="right"
                            >
                              {row.noticeUserCount > 0
                                ? row.noticeUserCount
                                : "--"}
                            </TableCell>
                            <TableCell>
                              <Tooltip title="نمایش" arrow>
                                <VisibilityIcon
                                  scale="scale(1.8) "
                                  className=" enableMoreHorizIcon cursorPointer"
                                  onClick={() =>
                                    handleShowNoticeItem(
                                      rowIndex,
                                      row.noticeKey
                                    )
                                  }
                                />
                              </Tooltip>
                              <Tooltip title="ویرایش" arrow>
                                <EditIcon
                                  scale="scale(1.8) "
                                  className={`${
                                    row.canEdit
                                      ? " enableMoreHorizIcon cursorPointer"
                                      : " disableMoreHorizIcon "
                                  }`}
                                  onClick={
                                    row.canEdit
                                      ? () =>
                                          handleEditNoticeItem(
                                            rowIndex,
                                            row.noticeKey
                                          )
                                      : () => {}
                                  }
                                />
                              </Tooltip>
                              <Tooltip title="حذف" arrow>
                                <Button>
                                  <ModalRemoveSupplierNotice
                                    noticeKey={row.noticeKey}
                                    canEdit={row.canEdit}
                                    noticesData={data}
                                    setNoticesData={setData}
                                  />
                                </Button>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div></div>
          <div>
            <Grid container spacing={2} alignItems="center">
              <Grid
                item
                xs={12}
                sm={4}
                display="flex"
                justifyContent={{ xs: "center", sm: "flex-start" }}
              >
                <span
                  style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>{pageInfo.total}</span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={12} sm={4} display="flex" justifyContent="center">
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  sx={{
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                  }}
                  count={
                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={12} sm={4}></Grid>
            </Grid>
          </div>
        </Grid>
        <ModalSuplierInfo
          openModel={openModal}
          setOpenModal={setOpenModal}
          noticeKey={noticeKeyModal}
        />
        <ModalNotice
          openModalShowNoticeInfo={openModalShowNoticeInfo}
          setOpenModalShowNoticeInfo={setOpenModalShowNoticeInfo}
          noticeKey={noticeKeyModalShowNotice}
          setSendConfirmation={setSendConfirmation}
          setOpenVerifyModal={setOpenVerifyModal}
        />
      </Grid>
    </>
  );
}
